import { render, staticRenderFns } from "./stepDocumentacao.vue?vue&type=template&id=6484a5af&scoped=true"
import script from "./stepDocumentacao.vue?vue&type=script&lang=ts"
export * from "./stepDocumentacao.vue?vue&type=script&lang=ts"
import style0 from "./stepDocumentacao.vue?vue&type=style&index=0&id=6484a5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484a5af",
  null
  
)

export default component.exports